$(document).ready(function(){
    
  // General Message
  $('.generalmessage').prependTo('header');

});

$(window).load(function(){

  const setCustomEventDates = () => {
    const eventDate = $('#siteInfoBannerWidget #eventDates').text();
    console.log(eventDate);
    $('.countdown-date').text(eventDate);
  }

  setCustomEventDates();

  setTimeout(function() {
    setCustomEventDates();
  }, 1000);
});